/* eslint-disable no-unreachable */
export const rendererCountDown = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
}) => {
    // Render a countdown
    if (completed) {
        return <span>Ended</span>
    }
    if (days > 1) {
        return (
            <span>
                {days}D : {hours}H : {minutes}M : {seconds}S
            </span>
        );
    } else if (days === 1) {
        return (
            <span>
                {days}D : {hours}H : {minutes}M : {seconds}S
            </span>
        );
    } else {
        return (
            <span>
                {hours}H : {minutes}M : {seconds}S
            </span>
        );
    }
};

export const rendererCountDown1 = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
}) => {
    // Render a countdown
    if (completed) {
        return <span>Ended</span>
    }
    if (days > 1) {
        return (
            <span>
                {days}<span className="time-05">d</span> : {hours}<span className="time-05">h</span> : {minutes}<span className="time-05">m</span> : {seconds}<span className="time-05">s</span>
            </span>
        );
    } else if (days === 1) {
        return (
            <span>
                {days}<span className="time-05">d</span> : {hours}<span className="time-05">h</span> : {minutes}<span className="time-05">m</span> : {seconds}<span className="time-05">s</span>
            </span>
        );
    } else {
        return (
            <span>
                {hours}<span className="time-05">h</span> : {minutes}<span className="time-05">m</span> : {seconds}<span className="time-05">s</span>
            </span>
        );
    }
};

export const renderTextTime = (value) => {
    switch (value) {
        case 1:
            return 'SALE Starts In'
            break;
        case 2:
            return 'SALE Ends In'
            break;
        case 3:
            return 'SALE Ends In'
            break;
        default:
            return 'TBA'
            break;
    }
}

export function formatDateSchedule(dateString) {
    const date = new Date(dateString * 1000); // Chuyển từ giây sang mili giây
    // Lấy thông tin ngày tháng năm
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
    const year = date.getUTCFullYear();

    // Lấy thông tin giờ phút
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Đổi sang 12 giờ
    const formattedMinutes = minutes.toString().padStart(2, '0');

    // Xác định hậu tố cho ngày (st, nd, rd, th)
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const suffix = (day % 10 > 3 || [11, 12, 13].includes(day)) ? 'th' : suffixes[day % 10] || 'th';

    // Ghép chuỗi theo định dạng mong muốn
    return (
        <div className="sche-cus">
            {month} {day}{suffix} {year} {" "}
            <span style={{ color: "#2C2C69", fontSize: "14px", fontWeight: "400", marginTop: '0px' }}>
                {formattedHours}:{formattedMinutes} {period}  - UTC
            </span>

        </div>
    );

}
export function formatDateSchedule1(dateString) {
    const date = new Date(dateString);

    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', { month: 'long', timeZone: 'UTC' });
    const year = date.getUTCFullYear();

    // Lấy thông tin giờ phút
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const period = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Đổi sang 12 giờ
    const formattedMinutes = minutes.toString().padStart(2, '0');

    // Xác định hậu tố cho ngày (st, nd, rd, th)
    const suffixes = ['th', 'st', 'nd', 'rd'];
    const suffix = (day % 10 > 3 || [11, 12, 13].includes(day)) ? 'th' : suffixes[day % 10] || 'th';

    // Ghép chuỗi theo định dạng mong muốn
    return (
        <div className="sche-cus">
            {month} {day}{suffix} {year} {" "}
            <span style={{ color: "#2C2C69", fontSize: "14px", fontWeight: "400" }}>
                {formattedHours}:{formattedMinutes} {period}  - UTC
            </span>

        </div>
    );


}